import { Box, Typography } from '@mui/material';
import Paper1 from 'assets/Paper1.webp';
import Paper2 from 'assets/Paper2.webp';
import { allowedFilesMap } from './DataSetForm';

export default function PaperDescription() {
  return (
    <Box>
      <Typography variant='h6'>"Paper" Chunk method description:</Typography>
      <Typography marginTop={2}>Supported file formats are {allowedFilesMap.naive.join(', ')}.</Typography>
      <ul>
        <li>Papers will be split by section, such as abstract, 1.1, 1.2.</li>
      </ul>
      <Typography>
        This approach enables the LLM to summarize the paper more effectively and to provide more comprehensive,
        understandable responses. However, it also increases the context for AI conversations and adds to the
        computational cost for the LLM. So during a conversation, consider reducing the value of ‘topN’.
      </Typography>
      <Typography fontWeight='500'>"Paper" Examples</Typography>
      <Typography marginBottom={3}>The following screenshots are presented to facilitate understanding.</Typography>
      <Box display='flex' overflow='auto' justifyContent='center' gap={1}>
        <img src={Paper1} alt='Paper1' width={320} />
        <img src={Paper2} alt='Paper2' width={320} />
      </Box>
    </Box>
  );
}
